import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const Navbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const isPortfolioPage =
    location.pathname === "/galleries" ||
    location.pathname.startsWith("/collections/");
  const navColor = isPortfolioPage
    ? "text-white hover:text-white/75"
    : "text-gray-800 hover:text-gray-700";
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // ✅ Check if user is authenticated (has a valid token)
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, [location.pathname]); 

  return (
    <nav className="absolute top-0 left-0 w-full z-20 overflow-x-hidden">
      <div className="flex flex-col justify-center items-center w-full">
        <div className="flex justify-between items-center w-full h-full text-sm sm:text-xl py-2 sm:py-4 px-4">
          <div className="flex justify-center items-center w-full">
            <Link
              to="/"
              className={`${navColor} no-underline text-center px-2 sm:px-5 py-1 sm:py-2 font-bold`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`${navColor} no-underline text-center px-2 sm:px-5 py-1 sm:py-2 font-bold`}
            >
              About
            </Link>
            <Link
              to="/pricing"
              className={`${navColor} no-underline text-center px-2 sm:px-5 py-1 sm:py-2 font-bold`}
            >
              Pricing
            </Link>
            <Link
              to="/galleries"
              className={`${navColor} no-underline text-center px-2 sm:px-5 py-1 sm:py-2 font-bold`}
            >
              Collections
            </Link>
            {isAuthenticated && (
              <Link
                to="/dashboard"
                className={`${navColor} no-underline text-center px-2 sm:px-5 py-1 sm:py-2 font-bold`}
              >
                Dashboard
              </Link>
            )}
          </div>
        </div>
        {!isHomePage && (
          <Link to="/">
            <div className={`flex-auto justify-center items-center text-center font-bold text-lg sm:text-xl ${isPortfolioPage ? "text-white" : "text-gray-800"}`}>
              Macaulay Takes Pictures
            </div>
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
